const socialShareLinks = document.querySelectorAll('.js-social-sharing');
 
// Social share links
[...socialShareLinks].forEach(el => {
    el.addEventListener('click', e => {
        e.preventDefault();
        
        let href = e.target.closest('a').href;
        
        window.open(
            href,
            'mywin',
            'left=20,top=20,width=500,height=300,toolbar=1,resizable=0'
        );
    });
});